import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDAUAbhLhKtpH2CySmgFeAgbX-hbZQgysM",
  authDomain: "etechnisian-6de54.firebaseapp.com",
  projectId: "etechnisian-6de54",
  storageBucket: "etechnisian-6de54.appspot.com",
  messagingSenderId: "962803136126",
  appId: "1:962803136126:web:3a38c05d82cbe955c48a2f",
  measurementId: "G-774PS0N53G",
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
